import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import ServicePill from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/components/nonFcaServices/ServicePill'
import { useUpdateOtherServiceMutation } from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/hooks/useUpdateOtherServiceMutation'
import useCurrentCompanyOrFail from '@/hooks/useCurrentCompanyOrFail'
import { QUERY_KEYS } from '@/lib/queryKeys'

interface Props {
  suggestedServiceName: string
  /**
   * The text currently saved to the company record
   */
  currentOtherServicesString: string
}

const SuggestedServicePill: React.FC<Props> = ({
  suggestedServiceName,
  currentOtherServicesString,
}) => {
  const queryClient = useQueryClient()
  const currentCompany = useCurrentCompanyOrFail()

  const updateOtherServiceMutation = useUpdateOtherServiceMutation({
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.company(currentCompany.id),
      }),
  })

  function handleDelete() {
    const newOtherServicesText = currentOtherServicesString
      .split(',')
      .filter(
        (part) =>
          part.trim().toLowerCase() !== suggestedServiceName.toLowerCase(),
      )
      .join(',')

    updateOtherServiceMutation.mutate(newOtherServicesText)
  }

  return (
    <ServicePill
      serviceName={suggestedServiceName}
      onDelete={handleDelete}
      isDeleting={updateOtherServiceMutation.isPending}
    />
  )
}

export default SuggestedServicePill
